import { createContext, useContext } from "react";

import { appendUrlSearchParams, navigate } from "../../../../hooks/navigation";

export type CalculatorContext = {
    query: URLSearchParams;
};

const context = createContext<CalculatorContext>({
    query: new URLSearchParams(),
});

export const CalculatorProvider = context.Provider;
export const CalculatorConsumer = context.Consumer;
export const useCalculatorContext = (): CalculatorContext =>
    useContext(context);

export const useNavigate = (to: string) => {
    const { query } = useCalculatorContext();

    return () => navigate(appendUrlSearchParams(to, query));
};
